import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class InAppBrowserService {
  // constructor(private inAppBrowser: InAppBrowser) {}

  // openUrl(url: string) {
  //   return new Promise((resolve, reject) => {
  //     const browser = this.inAppBrowser.create(url, "_blank");
  //     browser.on("exit").subscribe(event => {
  //       resolve(true);
  //     });
  //   });
  // }
}
